import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import * as THREE from "three";

export function AddClipper(components: OBC.Components, world: OBC.World) {
    const casters = components.get(OBC.Raycasters);
    casters.get(world);

    const clipper = components.get(OBC.Clipper);
    clipper.enabled = true;
    clipper.config.color = new THREE.Color(0x000000);
    const edges = components.get(OBCF.ClipEdges);
    clipper.Type = OBCF.EdgesPlane;
    const blueFill = new THREE.MeshBasicMaterial({ color: "lightblue", side: 2 });
    const blueLine = new THREE.LineBasicMaterial({ color: "blue" });
    const blueOutline = new THREE.MeshBasicMaterial({
        color: "blue",
        opacity: 0.5,
        side: 2,
        transparent: true,
    });

    // edges.styles.create(
    //     "Red lines",
    //     new Set([cube]),
    //     world,
    //     blueLine,
    //     blueFill,
    //     blueOutline,
    // );

    const salmonFill = new THREE.MeshBasicMaterial({ color: "salmon", side: 2 });
    const redLine = new THREE.LineBasicMaterial({ color: "red" });
    const redOutline = new THREE.MeshBasicMaterial({
        color: "red",
        opacity: 0.5,
        side: 2,
        transparent: true,
    });
    return clipper;
    // edges.styles.create(
    //     "Blue lines",
    //     new Set([cube2]),
    //     world,
    //     redLine,
    //     salmonFill,
    //     redOutline,
    // );
}